import { render, staticRenderFns } from "./task-files-modal.vue?vue&type=template&id=4c2733d6&scoped=true&"
import script from "./task-files-modal.vue?vue&type=script&lang=ts&"
export * from "./task-files-modal.vue?vue&type=script&lang=ts&"
import style0 from "./task-files-modal.vue?vue&type=style&index=0&id=4c2733d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2733d6",
  null
  
)

export default component.exports